import { NAMESPACE, NAMESPACE_NATIVE_FRAMEWORKS } from './constants';

export const PARSE_ESPRESSO_JOB = `${NAMESPACE}/PARSE_ESPRESSO_JOB`;
export const PARSE_JUNIT = `${NAMESPACE}/PARSE_JUNIT`;
export const PARSE_XCUITEST_JOB = `${NAMESPACE}/PARSE_XCUITEST_JOB`;
export const PARSE_NATIVE_FRAMEWORK_TEST_CASES = `${NAMESPACE_NATIVE_FRAMEWORKS}/PARSE_NATIVE_FRAMEWORK_TEST_CASES`;
